// import cv from "./CV.pdf";

export const socialLinks = [
  { name: "Github", link: "https://github.com/over-light" },
  // {name: "Resume", link: cv},
  // { name: "Mail", link: "mailto:ihelpbpov040@gmail.com" },
];
